<template>
  <div id="appf">
    <v-app id="inspire">
      <v-card>
        <v-tabs
          v-model="tab"
          background-color="deep-purple accent-4"
          centered
          icons-and-text
        >
          <v-tabs-slider></v-tabs-slider>

          <v-tab href="#tab-1">
            {{ $t('cyclic.information') }}
            <v-icon>info</v-icon>
          </v-tab>

          <v-tab href="#tab-2">
            {{ $t('cyclic.teams') }}
            <v-icon>perm_identity</v-icon>
          </v-tab>

          <v-tab href="#tab-3">
            {{ $t('cyclic.schemas') }}
            <v-icon>assignment</v-icon>
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <v-tab-item
            value="tab-1"
          >
            <v-card flat>
              <v-card-text> <Info v-bind:infoData="cyclic.cyclic_definition"></Info> </v-card-text>
            </v-card>
          </v-tab-item>

          <v-tab-item
            value="tab-2"
          >
            <v-card flat>
              <v-card-text> <Teams v-bind:teams="cyclic.teams"></Teams> </v-card-text>
            </v-card>
          </v-tab-item>

          <v-tab-item
            value="tab-3"
          >
            <v-card flat>
              <v-card-text> <Schemas v-bind:schemas="cyclic.schemas"></Schemas> </v-card-text>
            </v-card>
          </v-tab-item>

        </v-tabs-items>

      </v-card>
    </v-app>
  </div>
</template>

<script>
import http from '@/plugins/http'
import Info from './definition/view/Info.vue'
import Teams from './definition/view/Teams.vue'
import Schemas from './definition/view/Schemas.vue'

export default {
  components: {
    Info,
    Teams,
    Schemas
  },
  data() {
    return {
      basicValid: false,
      cyclic:{},
      stepper: 1,
      loading: false,
      bottomNav: 3,
      tab: null
    }
  },
  computed: {
  },
  created() {
    this.loadCyclic()
  },
  methods: {
    loadCyclic(){
      this.loading = true
      http.get('cyclic/'+ this.$route.params.cyclicId)
          .then(response => {
            this.cyclic = response.data

          }).catch(() => {
        this.loading = false
      })
    }
  },
}
</script>

<style>

</style>
